/* tslint:disable */
/* eslint-disable */
/**
 * Solaris User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetCardActivationStatus200Response
 */
export interface GetCardActivationStatus200Response {
    /**
     * Activation status
     * @type {string}
     * @memberof GetCardActivationStatus200Response
     */
    'status': GetCardActivationStatus200ResponseStatusEnum;
    /**
     * Card account ID
     * @type {string}
     * @memberof GetCardActivationStatus200Response
     */
    'cardAccountId': string;
    /**
     * User ID who specified the PIN (optional, only available for PIN-specified cards)
     * @type {string}
     * @memberof GetCardActivationStatus200Response
     */
    'pinSpecifiedUserId'?: string;
}

export const GetCardActivationStatus200ResponseStatusEnum = {
    newActivatable: 'NEW_ACTIVATABLE',
    renewalActivatable: 'RENEWAL_ACTIVATABLE',
    alreadyActivated: 'ALREADY_ACTIVATED'
} as const;

export type GetCardActivationStatus200ResponseStatusEnum = typeof GetCardActivationStatus200ResponseStatusEnum[keyof typeof GetCardActivationStatus200ResponseStatusEnum];


